import { useSelector } from 'react-redux';

import { Button } from '@/components/ui/button';
import { RosterEntry } from 'components/IAP/hooks/incidentRoster/incidentRoster.types';
import { useSendSeatActivationRequests } from 'hooks/incident/useRoster';
import { selectUserGuid } from 'slices/commonSelectors';

import { periodWindowLabel, unsentSeatCount } from './rosterPeriods';

/**
 * HWCG: names the period the seat modal is showing, with its window, and sends
 * the activation request to every assignee on this position not yet sent one.
 */
export function PositionPeriodHeader({
  incidentId,
  groupId,
  positionId,
  label,
  start,
  end,
  members,
  plannedPeriodId,
}: {
  incidentId: string;
  groupId: string;
  positionId: string;
  label: string;
  start: string | null | undefined;
  end: string | null | undefined;
  members: RosterEntry[];
  plannedPeriodId?: string | null;
}) {
  const viewerGuid = useSelector(selectUserGuid);
  const send = useSendSeatActivationRequests(incidentId, groupId);
  const unsent = unsentSeatCount(members, {
    excludeUserId: viewerGuid,
    positionId,
  });

  return (
    <div className="tw:flex tw:flex-wrap tw:items-center tw:justify-between tw:gap-2 tw:rounded-md tw:border tw:border-border tw:px-3 tw:py-2">
      <div className="tw:flex tw:flex-col">
        <span className="tw:text-sm tw:font-semibold">{label}</span>
        <span className="tw:text-xs tw:text-muted-foreground">
          {periodWindowLabel(start, end)}
        </span>
      </div>
      <Button
        type="button"
        size="sm"
        variant="outline"
        disabled={unsent === 0 || send.isPending}
        onClick={() => send.mutate({ plannedPeriodId, positionId })}
      >
        {send.isPending
          ? 'Sending…'
          : `Send Activation Request to All Not Yet Sent Request (${unsent})`}
      </Button>
    </div>
  );
}
